/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CancelablePromise } from '../core/CancelablePromise';
import { OpenAPI } from '../core/OpenAPI';
import { request as __request } from '../core/request';

export class AbpAspNetCoreMvcDaprEventsService {

    /**
     * @returns void 
     * @throws ApiError
     */
    public static postApiAwardApiAbpDaprEvent(): CancelablePromise<void> {
        return __request(OpenAPI, {
            method: 'POST',
            url: '/api/award/api/abp/dapr/event',
            errors: {
                400: `Bad Request`,
                401: `Unauthorized`,
                403: `Forbidden`,
                404: `Not Found`,
                500: `Internal Server Error`,
                501: `Not Implemented`,
            },
        });
    }

}
